var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"icon":"","small":"","to":{ name: 'ManagerSettingsPropertyEditor', params: { id: _vm.params.data.id } }}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(" edit ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }